import { defineStore } from 'pinia'
import { taxTypesApi } from '../services/api/tax-types'
import { logger } from '../utils/logger'

export const useTaxTypesStore = defineStore('taxTypes', {
    state: () => ({
        taxTypes: [],
        selectedTaxes: [],
        totalAmount: 0,
        loading: false,
        error: null,
        lastFetch: null
    }),

    getters: {
        availableTaxTypes: (state) => {
            return state.taxTypes.filter(tax => tax.status === 'A')
        },
        selectedTaxIds: (state) => {
            return state.selectedTaxes.map(tax => tax.id)
        },
        totalTaxAmount: (state) => {
            return state.selectedTaxes.reduce((sum, tax) => sum + tax.amount, 0)
        },
        getTotalAmount: (state) => state.totalAmount,
    },

    actions: {
        async fetchTaxTypes() {
            // Don't fetch if we've fetched recently (within 5 minutes)
            if (this.lastFetch && (Date.now() - this.lastFetch) < 300000) {
                // console.log('Skipping fetch - data was recently loaded')
                return
            }

            this.loading = true
            this.error = null
            
            try {
                // console.log('Making API call to getTaxTypes...')
                const data = await taxTypesApi.getTaxTypes()
                // console.log('Raw API response:', data)

                this.taxTypes = data.map(tax => ({
                    ...tax,
                    percent: Number(tax.percent),
                    id: Number(tax.id),
                    company_id: Number(tax.company_id)
                }))
                
                this.lastFetch = Date.now()
                logger.info('Tax types loaded:', {
                    count: this.taxTypes.length,
                    taxes: this.taxTypes.map(t => ({ 
                        id: t.id, 
                        name: t.name, 
                        percent: `${t.percent}%` 
                    }))
                })
            } catch (error) {
                console.error('Error in fetchTaxTypes:', error)
                this.error = error.message
                logger.error('Failed to load tax types:', error)
            } finally {
                // console.log('fetchTaxTypes completed, loading set to false')
                this.loading = false
            }
        },
        setSelectedTaxes(taxes, subtotal) {
            this.selectedTaxes = taxes.map(tax => ({
                ...tax,
                amount: Math.round(subtotal * (tax.percent / 100)),
                tax_type_id: tax.id
            }))
        },
        setTotalAmount(amount) {
            this.totalAmount = amount;
        },
    }
})
